<template>

	
	<!-- page content -->
	<div class="container-fluid">
		<div class="row">
			<div class="col-lg-12 col-md-12 col-sm-12 mx-auto user-panel mb-5">

                <div class="row">
                    <div class="col">

                        <div class="row page-header">
                            <div class="col">
                                <h3>Auto Approval System</h3>
                            </div>
                        </div>
                    </div>
                </div>
				
                <div class="row">
                    <div class="col">

                        <div class="card">
                            <div class="card-header">
                                Settings
                            </div>
                            <div class="card-block p-4">
                               Enable?
                            </div>
                        </div>
                       
                    </div>
                </div>

                <div class="row" style="margin-top: 20px;">
                    <div class="col-md-4">
                        <div class="card">
                            <div class="card-header">
                                Categories
                                <button class="btn btn-primary pull-right btn-sm" data-toggle="modal" data-target="#addAutoApproveCategoryModal">Add a Category</button>
                            </div>
                            <div class="card-block">
                                <ul class="list-group">
                                    <li class="list-group-item" v-bind:class="{ active: selectedCategory == category.id }" v-for="category in categories" v-on:click="toggleSelectedCategory(category)">{{ category.title }}</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4" v-if="selectedCategory !== null">
                        <div class="card">
                            <div class="card-header">
                                {{ selectedCategoryTitle }}'s Breakdowns
                                <button class="btn btn-primary pull-right btn-sm" data-toggle="modal" data-target="#addAutoApproveBreakdownModal" v-on:click="openBreakdownModal()">Add a Breakdown</button>
                            </div>
                            <div class="card-block">
                                <ul class="list-group">
                                    <li class="list-group-item" v-for="breakdown in breakdowns">{{ breakdown.description }} - ${{ breakdown.price }}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

			</div>
		</div>

        <add-auto-approve-breakdown-modal></add-auto-approve-breakdown-modal>
        <add-auto-approve-category-modal></add-auto-approve-category-modal>

	</div>

			
</template>

<script>
    import { EventBus } from '../../../utils/events';
    import * as Config from '../../../config'
    import { mapState, mapGetters } from 'vuex';

    import AddAutoApproveBreakdownModal from '../modals/AddAutoApproveBreakdownModal'
    import AddAutoApproveCategoryModal from '../modals/AddAutoApproveCategoryModal'

	export default {
		name: 'AutoApprovalSystem',
		data () {
			return {
                categories: [],
                breakdowns: [],
                selectedCategory: null,
                selectedCategoryTitle: null,
                selectedBreakdown: null,
			}
        },
        components: {
            'add-auto-approve-breakdown-modal': AddAutoApproveBreakdownModal,
            'add-auto-approve-category-modal': AddAutoApproveCategoryModal
		},
        mounted() {
            this.getCategories();

            this.$nextTick(function () {
                EventBus.$on('admin-auto-approve-add-category-refresh-data', this.getCategories);
                EventBus.$on('admin-auto-approve-add-breakdown-refresh-data', this.getBreakdowns);
            }.bind(this));
        },
        methods: {
            ...mapGetters([
                'getAuthorizationHeader',
            ]),
            getCategories() {
                var _this = this;
                this.$http.get(Config.apiPath + "/api/v2/admin/auto-approval-system/categories", this.getAuthorizationHeader()).then((response) => {
                    _this.categories = response.data
                });
            },
            getBreakdowns(id) {
                var _this = this;
                this.$http.get(Config.apiPath + "/api/v2/admin/auto-approval-system/breakdowns/" + id, this.getAuthorizationHeader()).then((response) => {
                    _this.breakdowns = response.data
                });
            },
            toggleSelectedCategory(data) {
                this.selectedCategory = data.id
                this.selectedCategoryTitle = data.title
                this.getBreakdowns(data.id)
            },

            openBreakdownModal() {
                console.log(this.selectedCategory)
                EventBus.$emit('admin-auto-approve-add-breakdown-open-modal', this.selectedCategory);
            }

        },
        filters: {
            parseMarketType: function(data) {
                var lower = data.toLowerCase();
                return lower.replace(/(^| )(\w)/g, function(x) {
                    return x.toUpperCase();
                });
            }
        }
	}
</script>

<style scoped>

    .list-group-item.active {
        background-color: #0055A3;
        border: none;
    }

</style>
